export function FormateDate(string) {
    let date = new Date(string);

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${year}-${month}-${day}`;
}

export function FormatDateUK(string) {
    let date = new Date(string);

    let day = date.getDate();
    let month = date.getMonth() + 1;
    let year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export function snapshotToArray(snapshot) {
    var returnArr = [];

    snapshot.forEach(function (childSnapshot) {
        var item = childSnapshot.val();
        item.key = childSnapshot.key;

        returnArr.push(item);
    });

    return returnArr;
};

export function formatItemDate(date) {

    let monthNames = [

        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"

    ];

    let dueDate = new Date(date);
    let dueDateMonth = dueDate.getMonth();

    return dueDate.getDate() + ' ' + monthNames[dueDateMonth];

}

export const searchUsers = {
    values: ['key', 'name', 'surname', 'email'],
    title: ['name', 'surname']
}

export const searchDependencies = {
    values: ['key', 'name'],
    title: ['name']
}

export function stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase();

    // remove accents, swap ñ for n, etc
    var from = "àáäâèéëêìíïîòóöôùúüûñç·/_,:;";
    var to = "aaaaeeeeiiiioooouuuunc------";
    for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-'); // collapse dashes

    return str;
}

export function getStatus(item, dependencies) {
    let date = new Date();

    if (item.status === "completed") {
        return "completed";
    }

    if (item.status === "hold") {
        return "hold";
    }
    if (item.status === "delayed") {
        return "delayed";
    }

    if (new Date(item.start) > date) {
        return "scheduled";
    }

    if (date > new Date(item.finish)) {
        return "delayed";
    }
    let warning = false;
    dependencies.map((dept, index) => {
        if (dept.children.findIndex(x => x == item.key) !== -1) {

            if (dept.status == 'hold' || (dept.status == 'scheduled' && new Date() > new Date(dept.finish))) {

                warning = true;

            }
        }
    });
    if (warning) {
        return 'warning';
    } else {
        return "progress";
    }
}

export function getObjectiveStatus(item) {
    let date = new Date();

    if (item.status === "completed") {
        return "completed";
    }

    if (item.status === "hold") {
        return "hold";
    }

    if (new Date(item.start) > date) {
        return "scheduled";
    }

    if (date > new Date(item.finish)) {
        return "delayed";
    }

    return "progress";
}

export function updatedToday(last_updated) {
    let date = new Date(last_updated);
    const today = new Date()

    return date.getDate() == today.getDate() &&
        date.getMonth() == today.getMonth() &&
        date.getFullYear() == today.getFullYear()
}